// import { gsap } from 'gsap';
// import { ScrollTrigger } from 'gsap/ScrollTrigger';

class StickyHeader {
    constructor() {
        this.header = document.querySelector('.header');
        this.showAnim = null;
        this.events();
    }

    events() {
        window.addEventListener('scroll', this.setSticky.bind(this));

        window.addEventListener('resize', this.setSticky.bind(this));

        window.addEventListener('load', this.setSticky.bind(this));

        window.addEventListener('orientationchange', this.setSticky.bind(this));

        // this.initAnim();
    }

    // Methods
    setSticky() {
        if (window.scrollY > 50) {
            this.header.classList.add('sticky');
        } else {
            this.header.classList.remove('sticky');
        }
    }

    // initAnim() {
    //     this.showAnim = gsap
    //         .from(this.header, {
    //             yPercent: -100,
    //             paused: true,
    //             duration: 0.4,
    //         })
    //         .progress(1);

    //     ScrollTrigger.create({
    //         start: 'top top',
    //         end: 99999,
    //         onUpdate: self => {
    //             self.direction === -1 ? this.showHeader() : this.hideHeader();
    //         },
    //     });
    // }

    // showHeader() {
    //     this.showAnim.play();
    // }

    // hideHeader() {
    //     this.showAnim.reverse();
    // }
}

export default new StickyHeader();
